import React, { useEffect, useRef } from 'react';
import './RunningScrollCard.css';

const RunningScrollCard = ({ children, className }) => {
  const cardRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current || !cardRef.current) return;

      const scrollPosition = window.scrollY;
      const elementTop = containerRef.current.getBoundingClientRect().top + scrollPosition;
      const elementHeight = containerRef.current.offsetHeight;
      const windowHeight = window.innerHeight;
      
      // Calculate how far the element is through the viewport
      const scrollPercentage = (scrollPosition + windowHeight - elementTop) / (elementHeight + windowHeight);
      
      // Apply transform based on scroll position
      if (scrollPercentage >= 0 && scrollPercentage <= 1) {
        const translateY = (0.5 - scrollPercentage) * 50; // Move from -25px to +25px
        const scale = 0.95 + (scrollPercentage * 0.1); // Scale from 0.95 to 1.05
        const opacity = 0.7 + (scrollPercentage * 0.3); // Opacity from 0.7 to 1.0
        
        cardRef.current.style.transform = `translateY(${translateY}px) scale(${scale})`;
        cardRef.current.style.opacity = opacity;
      }
    };

    // Add scroll listener
    window.addEventListener('scroll', handleScroll);
    
    // Initial check
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`running-scroll-card-container ${className || ''}`} ref={containerRef}>
      <div className="running-scroll-card" ref={cardRef}>
        {children}
      </div>
    </div>
  );
};

export default RunningScrollCard;
